module.exports = __webpack_public_path__ + "static/img/woxing-hotal.290a491a.png";